import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Feedback = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!name.trim() || !email.trim() || !message.trim()) {
      setError("Please fill in your name, email, and a message.");
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${API}/feedback`, {
        name: name.trim(),
        email: email.trim(),
        message: message.trim(),
      });
      setSent(true);
    } catch (err) {
      setError(
        err.response?.data?.detail || "Something went wrong sending your feedback. Please try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen w-full relative overflow-x-hidden text-white">
      <div
        className="fixed inset-0 z-[-1]"
        style={{
          background:
            "radial-gradient(900px 560px at 8% -6%, rgba(255,0,85,0.32), transparent 60%), radial-gradient(900px 560px at 94% 10%, rgba(0,240,255,0.24), transparent 60%), radial-gradient(700px 520px at 85% 92%, rgba(0,240,255,0.14), transparent 60%), #050508",
        }}
      />
      <div className="relative z-10 max-w-xl mx-auto px-4 py-12 sm:py-16">
        <div className="backdrop-blur-2xl bg-black/40 border border-white/10 rounded-3xl p-6 sm:p-10 shadow-2xl">
          <h1
            className="text-3xl sm:text-4xl mb-2 text-center"
            style={{ fontFamily: "Anton, sans-serif" }}
          >
            SEND US <span className="text-[#00F0FF]">FEEDBACK</span>
          </h1>
          <p className="text-[#A1A1AA] text-sm text-center mb-8">
            Found a bug, got an idea, or just want to say hi? We read every message.
          </p>

          {sent ? (
            <div className="text-center py-6" data-testid="feedback-success">
              <div className="text-4xl mb-3">🎉</div>
              <p className="text-white text-lg font-semibold mb-1">Thanks!</p>
              <p className="text-[#A1A1AA] text-sm">Your message is on its way to the Tap First team.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4" data-testid="feedback-form">
              <input
                type="text"
                placeholder="YOUR NAME"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full bg-white/5 border border-white/10 text-white rounded-xl px-4 py-4 text-center text-xl font-secondary focus:border-[#00F0FF] focus:ring-1 focus:ring-[#00F0FF] outline-none transition-all"
                maxLength={100}
                data-testid="feedback-name-input"
              />
              <input
                type="email"
                placeholder="YOUR EMAIL"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-white/5 border border-white/10 text-white rounded-xl px-4 py-4 text-center text-xl font-secondary focus:border-[#00F0FF] focus:ring-1 focus:ring-[#00F0FF] outline-none transition-all"
                maxLength={150}
                data-testid="feedback-email-input"
              />
              <textarea
                placeholder="YOUR MESSAGE"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows={5}
                className="w-full bg-white/5 border border-white/10 text-white rounded-xl px-4 py-4 text-base font-secondary focus:border-[#00F0FF] focus:ring-1 focus:ring-[#00F0FF] outline-none transition-all resize-none"
                maxLength={5000}
                data-testid="feedback-message-input"
              />
              {error && (
                <div className="text-[#FF0055] text-center text-sm" data-testid="feedback-error">
                  {error}
                </div>
              )}
              <button
                type="submit"
                disabled={submitting}
                className="w-full py-4 mt-4 bg-[#00F0FF] text-black font-primary text-xl tracking-wide rounded-xl shadow-[0_0_20px_rgba(0,240,255,0.4)] hover:scale-[1.02] active:scale-95 transition-all uppercase disabled:opacity-50"
                style={{ fontFamily: "Anton, sans-serif" }}
                data-testid="feedback-submit-button"
              >
                {submitting ? "SENDING..." : "SEND FEEDBACK"}
              </button>
            </form>
          )}

          <p className="mt-10 text-center">
            <Link to="/" className="text-[#A1A1AA] hover:text-white text-sm">← Back to home</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Feedback;
